import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/w/$workspace/reports/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/w/$workspace/reports/support", params, search: {} })
  },
})
